import React, {  useState } from 'react';

import Dialog from 'components/RMSDialog';
import { closeAddWarrant } from 'reducers/PersonDialogsReducer';
import { connect, useSelector } from 'react-redux';
import WarrantTab from './WarrantTab';

function AddWarrantDialog(props) {
  const initialPersonId = useSelector((state) => state.dialogs.addWarrant?.ptsPersonID);
  const [isCloseClick, setIsCloseClick] = useState(false);
  const close = () => {
    //props.closeAddWarrant();
    setIsCloseClick(true);
  };

  return (
    <Dialog toolbar fullScreen onClose={close} title="Add Warrant">
      <WarrantTab
        initialPersonId={initialPersonId}
        isCloseClick={isCloseClick}
        setIsCloseClick={setIsCloseClick}
      />
    </Dialog>
  );
}

export default connect(null, {
  closeAddWarrant,
})(AddWarrantDialog);
